'use strict';

var CollapsablePanelDirective = function CollapsablePanelDirective() {
  var config = {
    // used eg. in Data Extract
    DEFAULT_CONFIG: {
      headerVisibleWhenExpanded: true,
      headerLabelVisibleWhenExpanded: true,
      headerAtBottomWhenCollapsed: false,
      collapsedArrowClass: 'spark-icon-chevron-right',
      expandedArrowClass: 'spark-icon-chevron-down',
      arrowFloatClass: 'pull-left'
    },
    // used eg. in Seasonality
    CONFIG_1: {
      headerVisibleWhenExpanded: false,
      headerLabelVisibleWhenExpanded: true,
      headerAtBottomWhenCollapsed: true,
      collapsedArrowClass: 'spark-icon-chevron-down',
      expandedArrowClass: 'spark-icon-chevron-up',
      arrowFloatClass: 'pull-right'
    },
    // used eg. in ROM
    CONFIG_2: {
      headerVisibleWhenExpanded: true,
      headerLabelVisibleWhenExpanded: true,
      headerAtBottomWhenCollapsed: true,
      collapsedArrowClass: 'spark-icon-chevron-down',
      expandedArrowClass: 'spark-icon-chevron-up',
      arrowFloatClass: 'pull-right',
      collapsedByDefault: true
    },
    // used eg. in Demand Management
    CONFIG_3: {
      headerVisibleWhenExpanded: true,
      headerLabelVisibleWhenExpanded: true,
      headerAtBottomWhenCollapsed: false,
      scrollToShowEnitrePanel: true,
      collapsedArrowClass: 'spark-icon-chevron-down',
      expandedArrowClass: 'spark-icon-chevron-up',
      arrowFloatClass: 'pull-right',
      collapsedByDefault: true
    },
    // used eg. in Flight Management - for expanded by default panels
    CONFIG_4: {
      headerVisibleWhenExpanded: false,
      headerLabelVisibleWhenExpanded: true,
      headerAtBottomWhenCollapsed: true,
      collapsedArrowClass: 'spark-icon-chevron-down',
      expandedArrowClass: 'spark-icon-chevron-up',
      arrowFloatClass: 'pull-right',
      collapsedByDefault: false
    },
    // used eg. in Flight Management - for collapsed by default panels
    CONFIG_5: {
      headerVisibleWhenExpanded: false,
      headerLabelVisibleWhenExpanded: true,
      headerAtBottomWhenCollapsed: true,
      collapsedArrowClass: 'spark-icon-chevron-down',
      expandedArrowClass: 'spark-icon-chevron-up',
      arrowFloatClass: 'pull-right',
      collapsedByDefault: true
    }
  };
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: require('../templates/collapsable-panel.html'),
    scope: {
      header: '=',
      configType: '@',
      columnsProportion: '@',
      helpContent: '=?',
      preserveContent: '=?'
    },
    link: function link(scope, element) {
      scope.config = config[scope.configType || 'DEFAULT_CONFIG'];
      scope.isExpanded = !scope.config.collapsedByDefault;
      scope.columnsSize = scope.columnsProportion ? scope.columnsProportion.split('/') : [12, 0];
      scope.iconClass = function () {
        return scope.isExpanded ? scope.config.expandedArrowClass : scope.config.collapsedArrowClass;
      };
      scope.headerClass = function () {
        return scope.config.headerAtBottomWhenCollapsed ? 'last-xs' : 'first-xs';
      };
      scope.isHeaderSectionVisible = function () {
        return !scope.isExpanded || scope.isExpanded && scope.config.headerVisibleWhenExpanded;
      };
      scope.isHeaderLabelVisible = function () {
        return !scope.isExpanded || scope.isHeaderSectionVisible() && scope.config.headerLabelVisibleWhenExpanded;
      };
      scope.scrollToPanel = function () {
        var closingTag = element.find('.closing-tag');
        element.closest('body').animate({
          scrollTop: closingTag.offset().top
        }, 'slow');
      };
      scope.collapseHandler = function () {
        scope.isExpanded = !scope.isExpanded;
        scope.$broadcast('collapsable-panel-trigger', scope.isExpanded);
        scope.$emit('collapsable-panel-trigger', scope.isExpanded);
        if (scope.isExpanded && scope.config.scrollToShowEnitrePanel) {
          scope.scrollToPanel();
        }
      };
      scope.$on('collapsable-panel:collapse', function () {
        if (scope.isExpanded) {
          scope.collapseHandler();
        }
      });

      // initialize help popover
      scope.$watch('isExpanded', function () {
        var headerVisible = scope.isHeaderSectionVisible();

        // this is to show gdpr popovers in data extract collapsable panel
        element.find('.gdpr-popover').popover();
        if (headerVisible && scope.helpContent && !scope.helpInitialized) {
          element.find('.collapsable-panel-popover').popover();
          scope.helpInitialized = true;
        } else if (!headerVisible) {
          scope.helpInitialized = false;
        }
      });
    }
  };
};
CollapsablePanelDirective.$inject = [];
module.exports = CollapsablePanelDirective;